import { io, type Socket } from "socket.io-client";

// Socket URL juga di-derive dari window.location supaya LAN access works.
function deriveSocketUrl(): string {
  const envUrl = import.meta.env.VITE_SOCKET_URL;
  if (envUrl && !/localhost|127\.0\.0\.1/.test(envUrl)) return envUrl;
  const { protocol, hostname } = window.location;
  return `${protocol}//${hostname}:3010`;
}

const SOCKET_URL = deriveSocketUrl();

export function connectSocket(deviceToken: string): Socket {
  return io(SOCKET_URL, {
    auth: { device_token: deviceToken },
    transports: ["websocket"],
    reconnection: true,
    reconnectionDelay: 2000,
  });
}
